/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Map_Popup_Sessions_TitleInputs */

const en_ui_map_popup_sessions_title = /** @type {(inputs: Ui_Map_Popup_Sessions_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Sessions`)
};

const de_ui_map_popup_sessions_title = /** @type {(inputs: Ui_Map_Popup_Sessions_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Einheiten`)
};

/**
* | output |
* | --- |
* | "{count} Sessions" |
*
* @param {Ui_Map_Popup_Sessions_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_popup_sessions_title = /** @type {((inputs: Ui_Map_Popup_Sessions_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_Popup_Sessions_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_popup_sessions_title(inputs)
	return de_ui_map_popup_sessions_title(inputs)
});